// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"flexStyles_wrapper__o0KCw","checkBlock":"flexStyles_checkBlock__IiMLN","descriptionBlock":"flexStyles_descriptionBlock__WUTD1","tooltip":"flexStyles_tooltip__1xzDz"};